// Objective: Define the service to get the loan leads
import HttpClient from "../http/HttpClient";
import { LEAD_SERVICE_HOST, LEAD_API_PREFIX } from "../constants/RestConstants";
import { PaginationConst } from '../constants/AppConstant';

export const getPayments = async (leadId: string, pageNumber: number = 0, pageSize: number = PaginationConst.PAGE_SIZE, filter: string) => {
  try {
    const response = await HttpClient.GET({
      BASE_URL: LEAD_SERVICE_HOST,
      END_POINT: `${LEAD_API_PREFIX}/${leadId}/payments?${filter}`
    });
    return response;
  } catch (error) {
    console.error("Error fetching payments:", error);
    throw error;
  }
};

export const createdPayment = async (debitId: string, releaseObj: Object = {}) => {
  try {
    const response = await HttpClient.POST({
      BASE_URL: LEAD_SERVICE_HOST,
      END_POINT: `${LEAD_API_PREFIX}/debits/${debitId}/payments`,
      data: releaseObj,
    });
    return response;
  } catch (error) {
    console.error("Error creating payment:", error);
    throw error;
  }
};

export const getPaymentsByDebit = async (debitId: string, pageNumber: number = 0, pageSize: number = PaginationConst.PAGE_SIZE) => {
  try {
    const response = await HttpClient.GET({
      BASE_URL: LEAD_SERVICE_HOST,
      END_POINT: `${LEAD_API_PREFIX}/debits/${debitId}/payments?pageNumber=${pageNumber}&pageSize=${pageSize}`
    });
    return response;
  } catch (error) {
    console.error("Error fetching payments by debit:", error);
    throw error;
  }
};

export const createPayment = async (debitId: string, paymentData: any) => {
  try {
    const response = await HttpClient.POST({
      BASE_URL: LEAD_SERVICE_HOST,
      END_POINT: `${LEAD_API_PREFIX}/debits/${debitId}/payments`,
      data: paymentData,
    });
    return response;
  } catch (error) {
    console.error("Error creating payment:", error);
    throw error;
  }
};

export const getPaymentById = async (paymentId: string) => {
  try {
    const response = await HttpClient.GET({
      BASE_URL: LEAD_SERVICE_HOST,
      END_POINT: `${LEAD_API_PREFIX}/payments/${paymentId}`
    });
    return response;
  } catch (error) {
    console.error("Error fetching payment by ID:", error);
    throw error;
  }
};

export const updatePayment = async (paymentId: string, paymentData: any) => {
  try {
    const response = await HttpClient.PUT({
      BASE_URL: LEAD_SERVICE_HOST,
      END_POINT: `${LEAD_API_PREFIX}/payments/${paymentId}`,
      data: paymentData,
    });
    return response;
  } catch (error) {
    console.error("Error updating payment:", error);
    throw error;
  }
};

export const deletePayment = async (paymentId: string) => {
  try {
    const response = await HttpClient.DELETE({
      BASE_URL: LEAD_SERVICE_HOST,
      END_POINT: `${LEAD_API_PREFIX}/payments/${paymentId}`
    });
    return response;
  } catch (error) {
    console.error("Error deleting payment:", error);
    throw error;
  }
};

export const getAllPayments = async (pageNumber: number = 0, pageSize: number = PaginationConst.PAGE_SIZE) => {
  try {
    const response = await HttpClient.GET({
      BASE_URL: LEAD_SERVICE_HOST,
      END_POINT: `${LEAD_API_PREFIX}/payments?page=${pageNumber}&size=${pageSize}`
    });
    return response;
  } catch (error) {
    console.error("Error fetching all payments:", error);
    throw error;
  }
};